module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = 86
// module chunks = 0 1